// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fördermittel. Every selector is scoped to .funding-page; dialogs get it as rootClassName
   because they render outside the page. */

.funding-page .fu-full {
  width: 100%;
}

.funding-page .fu-small {
  font-size: 13px;
  color: var(--ds-text-muted);
}

.funding-page .fu-wrap {
  white-space: normal;
  overflow-wrap: anywhere;
}

.funding-page .fu-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: anywhere;
}

.funding-page .fu-empty-text {
  max-width: 480px;
  margin-inline: auto;
}

.funding-page .fu-program-filter {
  min-width: 220px;
  max-width: 100%;
}

/* ---- Editor header ---- */
.funding-page .fu-header {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  flex-wrap: wrap;
}

.funding-page .fu-header-title {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  flex: 1 1 0;
  min-width: 0;
}

.funding-page .fu-header-title h4 {
  margin: 0;
  overflow-wrap: anywhere;
}

.funding-page .fu-program {
  margin-block: var(--ds-space-2) var(--ds-space-3);
  overflow-wrap: anywhere;
}

.funding-page .fu-steps {
  margin-top: var(--ds-space-2);
}

.funding-page .fu-state {
  margin-inline-start: var(--ds-space-2);
}

/* ---- Measures ---- */
.funding-page .fu-checks {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-2);
}

.funding-page .fu-requirement {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--ds-space-2);
  padding-block: var(--ds-space-2);
  border-bottom: 1px solid var(--ds-border-soft);
}

.funding-page .fu-requirement:last-child {
  border-bottom: none;
}

.funding-page .fu-requirement-label {
  flex: 1 1 260px;
  min-width: 0;
  overflow-wrap: anywhere;
}

.funding-page .fu-number {
  width: 100%;
  max-width: 200px;
}

/* ---- Costs ---- */
.funding-page .fu-line {
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-md, 10px);
  padding: var(--ds-space-3);
  margin-bottom: var(--ds-space-3);
  background: var(--ds-surface);
}

.funding-page .fu-line-actions {
  display: flex;
  justify-content: flex-end;
}

.funding-page .fu-total-row td {
  font-weight: 600;
  background: var(--ds-surface-muted);
}

.funding-page .fu-estimate .ant-statistic-content {
  font-variant-numeric: tabular-nums;
}

/* ---- Checklist, deadlines, clause ---- */
.funding-page .fu-done {
  color: var(--ds-text-muted);
  text-decoration: line-through;
}

.funding-page .fu-clause {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  background: var(--ds-surface-muted);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-sm, 6px);
  padding: var(--ds-space-3);
}

.funding-page textarea.fu-json {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12px;
}

.funding-page .fu-errors {
  margin: 0;
  padding-inline-start: var(--ds-space-4);
}

.funding-page .fu-panel-item {
  cursor: pointer;
}

@media (max-width: 767px) {
  .funding-page .fu-line-actions {
    justify-content: flex-start;
  }

  .funding-page .fu-number {
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/funding/funding.css"],"names":[],"mappings":"AAAA;0CAC0C;;AAE1C;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iDAAiD;EACjD,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,kCAAkC;EAClC,wCAAwC;EACxC,0BAA0B;EAC1B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,2CAA2C;AAC3C;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mCAAmC;EACnC,uCAAuC;EACvC,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,qEAAqE;EACrE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Fördermittel. Every selector is scoped to .funding-page; dialogs get it as rootClassName\n   because they render outside the page. */\n\n.funding-page .fu-full {\n  width: 100%;\n}\n\n.funding-page .fu-small {\n  font-size: 13px;\n  color: var(--ds-text-muted);\n}\n\n.funding-page .fu-wrap {\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.funding-page .fu-clamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  overflow-wrap: anywhere;\n}\n\n.funding-page .fu-empty-text {\n  max-width: 480px;\n  margin-inline: auto;\n}\n\n.funding-page .fu-program-filter {\n  min-width: 220px;\n  max-width: 100%;\n}\n\n/* ---- Editor header ---- */\n.funding-page .fu-header {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  flex-wrap: wrap;\n}\n\n.funding-page .fu-header-title {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.funding-page .fu-header-title h4 {\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n\n.funding-page .fu-program {\n  margin-block: var(--ds-space-2) var(--ds-space-3);\n  overflow-wrap: anywhere;\n}\n\n.funding-page .fu-steps {\n  margin-top: var(--ds-space-2);\n}\n\n.funding-page .fu-state {\n  margin-inline-start: var(--ds-space-2);\n}\n\n/* ---- Measures ---- */\n.funding-page .fu-checks {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-2);\n}\n\n.funding-page .fu-requirement {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n  padding-block: var(--ds-space-2);\n  border-bottom: 1px solid var(--ds-border-soft);\n}\n\n.funding-page .fu-requirement:last-child {\n  border-bottom: none;\n}\n\n.funding-page .fu-requirement-label {\n  flex: 1 1 260px;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.funding-page .fu-number {\n  width: 100%;\n  max-width: 200px;\n}\n\n/* ---- Costs ---- */\n.funding-page .fu-line {\n  border: 1px solid var(--ds-border);\n  border-radius: var(--ds-radius-md, 10px);\n  padding: var(--ds-space-3);\n  margin-bottom: var(--ds-space-3);\n  background: var(--ds-surface);\n}\n\n.funding-page .fu-line-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.funding-page .fu-total-row td {\n  font-weight: 600;\n  background: var(--ds-surface-muted);\n}\n\n.funding-page .fu-estimate .ant-statistic-content {\n  font-variant-numeric: tabular-nums;\n}\n\n/* ---- Checklist, deadlines, clause ---- */\n.funding-page .fu-done {\n  color: var(--ds-text-muted);\n  text-decoration: line-through;\n}\n\n.funding-page .fu-clause {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  background: var(--ds-surface-muted);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-sm, 6px);\n  padding: var(--ds-space-3);\n}\n\n.funding-page textarea.fu-json {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 12px;\n}\n\n.funding-page .fu-errors {\n  margin: 0;\n  padding-inline-start: var(--ds-space-4);\n}\n\n.funding-page .fu-panel-item {\n  cursor: pointer;\n}\n\n@media (max-width: 767px) {\n  .funding-page .fu-line-actions {\n    justify-content: flex-start;\n  }\n\n  .funding-page .fu-number {\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
